import { render, staticRenderFns } from "./AppTemplateEditor.vue?vue&type=template&id=35afa44a&scoped=true"
import script from "./AppTemplateEditor.vue?vue&type=script&lang=js"
export * from "./AppTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./AppTemplateEditor.vue?vue&type=style&index=0&id=35afa44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35afa44a",
  null
  
)

export default component.exports